'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialMediaButtonsGrid = function (_React$Component) {
  _inherits(SocialMediaButtonsGrid, _React$Component);

  function SocialMediaButtonsGrid() {
    _classCallCheck(this, SocialMediaButtonsGrid);

    return _possibleConstructorReturn(this, (SocialMediaButtonsGrid.__proto__ || Object.getPrototypeOf(SocialMediaButtonsGrid)).apply(this, arguments));
  }

  _createClass(SocialMediaButtonsGrid, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          containerClassName = _props.containerClassName,
          buttonClassName = _props.buttonClassName,
          socialMediaConfig = _props.socialMediaConfig,
          size = _props.size,
          circular = _props.circular;

      var socialMediaKeys = Object.keys(socialMediaConfig).filter(function (key) {
        return socialMediaConfig[key].link;
      });
      return _react2.default.createElement(
        'div',
        { className: containerClassName },
        socialMediaKeys.map(function (key) {
          return _react2.default.createElement(_semanticUiReact.Button, {
            key: key,
            circular: circular,
            disabled: !socialMediaConfig[key].link,
            size: size,
            className: buttonClassName,
            icon: key,
            href: socialMediaConfig[key].link,
            target: '_new'
          });
        })
      );
    }
  }]);

  return SocialMediaButtonsGrid;
}(_react2.default.Component);

exports.default = SocialMediaButtonsGrid;


SocialMediaButtonsGrid.propTypes = {
  containerClassName: _propTypes2.default.string,
  buttonClassName: _propTypes2.default.string,
  socialMediaConfig: _propTypes2.default.shape({
    facebook: _propTypes2.default.obj,
    instagram: _propTypes2.default.obj,
    twitter: _propTypes2.default.obj,
    linkedin: _propTypes2.default.obj,
    github: _propTypes2.default.obj
  }).isRequired,
  size: _propTypes2.default.string,
  circular: _propTypes2.default.bool
};

SocialMediaButtonsGrid.defaultProps = {
  containerClassName: '',
  buttonClassName: '',
  size: 'large',
  circular: false
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/organisms/SocialMediaButtonsGrid/SocialMediaButtonsGrid.js
// module id = 514
// module chunks = 168707334958949